import React from 'react'
import DittoIcons from '../DittoIcons/index'
import MapNavIcons from '../MapNavIcons/index'
import FootPrinter from '../FootPrinterIcons/index'
// const MapNavIcons = React.lazy(() => import('../MapNavIcons/index'))
const MapIcons = React.lazy(() => import('../MapIcons/index'))

const HelpIcon = React.lazy(() => import('../HelpIcon'))
const LzIcon = React.lazy(() => import('../LzIcon')) //潞州
const WhiteBgHelpIcon = React.lazy(() => import('../HelpIcon/whitebgHelpIcon'))
const AddIcon = React.lazy(() => import('../AddIcon'))
const MoreIcon = React.lazy(() => import('../MoreIcon'))
const UserIcon = React.lazy(() => import('../UserIcon'))
const UserFullIcon = React.lazy(() => import('../UserFullIcon'))
const ExitIcon = React.lazy(() => import('../ExitIcon'))
const CollapseIcon = React.lazy(() => import('../CollapseIcon'))
const CircleCloseIcon = React.lazy(() => import('../CircleCloseIcon'))
const CloseIcon = React.lazy(() => import('../CloseIcon'))
const SignIcon = React.lazy(() => import('../SignIcon'))
const DownArrowIcon = React.lazy(() => import('../DownArrowIcon'))
const ChevronDownIcon = React.lazy(() => import('../ChevronDown'))
const ChevronUpIcon = React.lazy(() => import('../ChevronUp'))
const UpArrowIcon = React.lazy(() => import('../UpArrowIcon'))
const RightArrowIcon = React.lazy(() => import('../RightArrowIcon'))
const LeftArrowIcon = React.lazy(() => import('../LeftArrowIcon'))
const FilterIcon = React.lazy(() => import('../FilterIcon'))
const SuccessIcon = React.lazy(() => import('../SuccessIcon'))
const ErrorIcon = React.lazy(() => import('../ErrorIcon'))
const WarningIcon = React.lazy(() => import('../WarningIcon'))
const InfoIcon = React.lazy(() => import('../InfoIcon'))
const UserNameIcon = React.lazy(() => import('../UserNameIcon'))
const InputSuffixOkIcon = React.lazy(() => import('../InputSuffixOkIcon'))
const PasswordIcon = React.lazy(() => import('../PasswordIcon'))
const SmsCodeIcon = React.lazy(() => import('../SmsCodeIcon'))
const RegisterBackIcon = React.lazy(() => import('../RegisterBackIcon'))
const DownloadIcon = React.lazy(() => import('../DownloadIcon'))
const PlayIcon = React.lazy(() => import('../PlayIcon'))
const StarIcon = React.lazy(() => import('../StarIcon'))
const SolidStarIcon = React.lazy(() => import('../SolidStarIcon'))
const SettingIcon = React.lazy(() => import('../Setting'))
const CheckIcon = React.lazy(() => import('../Check'))
const RankIcon = React.lazy(() => import('../Rank'))
const CheckCircle = React.lazy(() => import('../CheckIcon'))
const SortIcon = React.lazy(() => import('../SortIcon'))
const UserGroupIcon = React.lazy(() => import('../UserGroupIcon'))
const UsersIcon = React.lazy(() => import('../UsersIcon'))
const MonkIcon = React.lazy(() => import('../MonkIcon'))
// const {
//   SchoolNavIcon,
//   MedicalNavIcon,
//   ChemicalNavIcon,
//   CoalNavIcon,
//   EnterpriseNavIcon,
//   GasNavIcon,
//   AccommodationNavIcon,
//   CultureNavIcon,
//   ReligionNavIcon,
//   TupermarketNavIcon,
//   TouristNavIcon,
//   DefaultNavIcon,
//   JzwzcbkIcon,
// } = MapNavIcons

const {
  SchoolIcon,
  SchoolIcon2,
  MedicalCare,
  Culture,
  Travel,
  Religion,
  Supermarket,
  Accommodation,
  ChemicalIndustry,
  Enterprise,
  GasStation,
  CoalMine,
} = MapIcons

const DocIcon = React.lazy(() => import('../DocIcon'))
const XlsIcon = React.lazy(() => import('../XlsIcon'))
const PdfIcon = React.lazy(() => import('../PdfIcon'))
const SearchIcon = React.lazy(() => import('../SearchIcon'))
const CircleAddIcon = React.lazy(() => import('../CircleAddIcon'))
const MinusIcon = React.lazy(() => import('../Minus'))
const CircleMinusIcon = React.lazy(() => import('../CircleMinus'))
const ImporterIcon = React.lazy(() => import('../ImporterIcon'))
const ExporterIcon = React.lazy(() => import('../ExporterIcon'))
const RecycleIcon = React.lazy(() => import('../RecycleIcon'))
const AlertIcon = React.lazy(() => import('../AlertIcon'))
const EditIcon = React.lazy(() => import('../EditIcon'))
const DeleteIcon = React.lazy(() => import('../DeleteIcon'))
const TimeIcon = React.lazy(() => import('../TimeIcon'))
const ZrzhLogoIcon = React.lazy(() => import('../ZrzhLogoIcon'))
const QuestionIcon = React.lazy(() => import('../QuestionIcon'))
const ProcessIcon = React.lazy(() => import('../ProcessIcon'))
const ExpandIcon = React.lazy(() => import('../ExpandIcon'))
const RetractIcon = React.lazy(() => import('../RetractIcon'))
const MarkIcon = React.lazy(() => import('../MarkIcon'))
const CancelIcon = React.lazy(() => import('../CancelIcon'))
const TreeSwitchIcon = React.lazy(() => import('../TreeSwitchIcon'))
const FontBoldIcon = React.lazy(() => import('../RichEditorIcons/FontBoldIcon'))
const FontItalicIcon = React.lazy(() =>
  import('../RichEditorIcons/FontItalicIcon')
)
const FontUderlineIcon = React.lazy(() =>
  import('../RichEditorIcons/FontUderlineIcon')
)
const FontColorIcon = React.lazy(() =>
  import('../RichEditorIcons/FontColorIcon')
)
const FontCodeIcon = React.lazy(() => import('../RichEditorIcons/FontCodeIcon'))
const FontH1Icon = React.lazy(() => import('../RichEditorIcons/FontH1Icon'))
const FontH2Icon = React.lazy(() => import('../RichEditorIcons/FontH2Icon'))
const FontQuoteIcon = React.lazy(() =>
  import('../RichEditorIcons/FontQuoteIcon')
)
const FontOrderListIcon = React.lazy(() =>
  import('../RichEditorIcons/FontOrderListIcon')
)
const FontBulletListIcon = React.lazy(() =>
  import('../RichEditorIcons/FontBulletListIcon')
)
const FontLeftIcon = React.lazy(() => import('../RichEditorIcons/FontLeftIcon'))
const FontCenterIcon = React.lazy(() =>
  import('../RichEditorIcons/FontCenterIcon')
)
const FontRightIcon = React.lazy(() =>
  import('../RichEditorIcons/FontRightIcon')
)
const FontJustifyIcon = React.lazy(() =>
  import('../RichEditorIcons/FontJustifyIcon')
)
const FontLineHeightIcon = React.lazy(() =>
  import('../RichEditorIcons/FontLineHeightIcon')
)
const FontIndentIcon = React.lazy(() =>
  import('../RichEditorIcons/FontIndentIcon')
)
const ImageIcon = React.lazy(() => import('../RichEditorIcons/ImageIcon'))
const EditorDeleteIcon = React.lazy(() =>
  import('../RichEditorIcons/DeleteIcon')
)
const ManualIcon = React.lazy(() => import('../ManualIcon'))
const RefreshIcon = React.lazy(() => import('../RefreshIcon'))
const LoginUserNameIcon = React.lazy(() => import('../LoginUserNameIcon'))
const LoginPasswordIcon = React.lazy(() => import('../LoginPasswordIcon'))
const LoginByPhoneIcon = React.lazy(() => import('../LoginByPhoneIcon'))
const LoginByPasswordIcon = React.lazy(() => import('../LoginByPasswordIcon'))
const LoginMobileIcon = React.lazy(() => import('../LoginMobileIcon'))
const NoticeIcon = React.lazy(() => import('../NoticeIcon'))
const ImportantNewsIcon = React.lazy(() => import('../ImportantNewsIcon'))
const StatuteIcon = React.lazy(() => import('../StatuteIcon'))
const GovernmentAffairsIcon = React.lazy(() =>
  import('../GovernmentAffairsIcon')
)
const ContractIcon = React.lazy(() => import('../ContractIcon'))
const InteractIcon = React.lazy(() => import('../InteractIcon'))
const GuideIcon = React.lazy(() => import('../GuideIcon'))
const SpecialColumnIcon = React.lazy(() => import('../SpecialColumnIcon'))
const CityIcon = React.lazy(() => import('../CityIcon'))
const InfomationIcon = React.lazy(() => import('../InfomationIcon'))
const LeaveMsgIcon = React.lazy(() => import('../LeaveMsgIcon'))
const LeftArrow1Icon = React.lazy(() => import('../LeftArrow1Icon'))

const PraiseIcon = React.lazy(() => import('../PraiseIcon'))
const CommentIcon = React.lazy(() => import('../CommentIcon'))
const ForwardIcon = React.lazy(() => import('../ForwardIcon'))
const AuthPrivateIcon = React.lazy(() => import('../AuthPrivateIcon'))
const AuthPublicIcon = React.lazy(() => import('../AuthPublicIcon'))
const MoveIcon = React.lazy(() => import('../MoveIcon'))
const WorkSpaceIcon = React.lazy(() => import('../WorkSpace'))
const RotateIcon = React.lazy(() => import('../rotate'))
const ZjsdjcIcon = React.lazy(() => import('../ZjsdjcIcon'))
const ZjwmsjIcon = React.lazy(() => import('../ZjwmsjIcon'))
const ZjddgfysbhrIcon = React.lazy(() => import('../ZjddgfysbhrIcon'))
const ZjwmdwglIcon = React.lazy(() => import('../ZjwmdwglIcon'))
const DefaultAvatarIcon = React.lazy(() => import('../DefaultAvatarIcon'))

const FoldUpIcon = React.lazy(() => import('../FoldUpIcon'))
const AppsIcon = React.lazy(() => import('../AppsIcon'))
const PointIcon = React.lazy(() => import('../PointIcon'))
const IndexLibIcon = React.lazy(() => import('../IndexLibIcon'))
const CategoryIcon = React.lazy(() => import('../CategoryIcon'))
const GwIcon = React.lazy(() => import('../GwIcon'))
const WbhjIcon = React.lazy(() => import('../WbhjIcon'))
const DdljflIcon = React.lazy(() => import('../DdljflIcon'))
const GxdwIcon = React.lazy(() => import('../GxdwIcon'))
const DdljflDemoIcon = React.lazy(() => import('../DdljflDemoIcon'))
const cyljsyIcon = React.lazy(() => import('../Navs/cyljsy'))
const khswsyIcon = React.lazy(() => import('../Navs/khswsy'))
const yhljsyIcon = React.lazy(() => import('../Navs/yhljsy'))
const ddyjkIcon = React.lazy(() => import('../Navs/ddyjk'))
const sbjkIcon = React.lazy(() => import('../Navs/sbjk'))
const cjtzIcon = React.lazy(() => import('../Navs/cjtz'))
const sbtzIcon = React.lazy(() => import('../Navs/sbtz'))
const sdjcIcon = React.lazy(() => import('../Navs/sdjc'))
const cltzIcon = React.lazy(() => import('../Navs/cltz'))
const rytzIcon = React.lazy(() => import('../Navs/rytz'))
const clsbIcon = React.lazy(() => import('../Navs/clsb'))
const xchdIcon = React.lazy(() => import('../Navs/xchd'))
const contarctIcon = React.lazy(() => import('../Contract'))
const expandIcon = React.lazy(() => import('../Expand'))
const hdIcon = React.lazy(() => import('../HdIcon'))
const ftIcon = React.lazy(() => import('../FtIcon'))

const {
  AddBoldIcon,
  LinkIcon,
  MultiSelect,
  MultiText,
  NumberIcon,
  SelectIcon,
  ShiftIcon,
  TextIcon,
  UnlinkIcon,
  GreenRightIcon,
  NormalFieldIcon,
  LinkNormalIcon,
  UnLinkNormalIcon,
  RedDeleteIcon,
  DragIcon,
  AreaIcon,
  GeolocationIcon,
  StandardIcon,
} = DittoIcons

const {
  SchoolNavIcon,
  MedicalNavIcon,
  ChemicalNavIcon,
  CoalNavIcon,
  EnterpriseNavIcon,
  GasNavIcon,
  AccommodationNavIcon,
  CultureNavIcon,
  ReligionNavIcon,
  TupermarketNavIcon,
  TouristNavIcon,
  DefaultNavIcon,
  JzwzcbkIcon,
  ShzzjznlIcon,
  SlxfdwyzbIcon,
  SqxzcjznlIcon,
  XzjdjznlIcon,
  YjbnsIcon,
  ZfzrzhglnlIcon,
  ZfzzhqsyzzIcon,
  yjsjIcon,
} = MapNavIcons

const { GeoIcon, CalendarIcon } = FootPrinter
// import {
//   SchoolNavIcon,
//   MedicalNavIcon,
//   ChemicalNavIcon,
//   CoalNavIcon,
//   EnterpriseNavIcon,
//   GasNavIcon,
//   AccommodationNavIcon,
//   CultureNavIcon,
//   ReligionNavIcon,
//   TupermarketNavIcon,
//   TouristNavIcon,
//   DefaultNavIcon,
// } from '../MapNavIcons'
// import {
//   SchoolIcon,
//   SchoolIcon2,
//   MedicalCare,
//   Culture,
//   Travel,
//   Religion,
//   Supermarket,
//   Accommodation,
//   ChemicalIndustry,
//   Enterprise,
//   GasStation,
//   CoalMine,
// } from '../MapIcons'

export const maps = {
  lz: LzIcon, //潞州
  help: HelpIcon,
  whiteBgHelp: WhiteBgHelpIcon,
  add: AddIcon,
  more: MoreIcon,
  user: UserIcon,
  exit: ExitIcon,
  collapse: CollapseIcon,
  circle: CircleCloseIcon,
  cancel: CancelIcon,
  close: CloseIcon,
  sign: SignIcon,
  downarrow: DownArrowIcon,
  uparrow: UpArrowIcon,
  leftarrow: LeftArrowIcon,
  rightarrow: RightArrowIcon,
  filter: FilterIcon,
  success: SuccessIcon,
  error: ErrorIcon,
  warning: WarningIcon,
  info: InfoIcon,
  rotate: RotateIcon,
  username: UserNameIcon,
  inputsuffixok: InputSuffixOkIcon,
  password: PasswordIcon,
  smscode: SmsCodeIcon,
  registerback: RegisterBackIcon,
  download: DownloadIcon,
  play: PlayIcon,
  star: StarIcon,
  solidstar: SolidStarIcon,
  schoolnav: SchoolNavIcon,
  medicalnav: MedicalNavIcon,
  chemicalnav: ChemicalNavIcon,
  coalnav: CoalNavIcon,
  enterprisenav: EnterpriseNavIcon,
  gasnav: GasNavIcon,
  accommodationnav: AccommodationNavIcon,
  culturenav: CultureNavIcon,
  religionnav: ReligionNavIcon,
  tupermarketnav: TupermarketNavIcon,
  touristnav: TouristNavIcon,
  defaultnav: DefaultNavIcon,
  school: SchoolIcon,
  school2: SchoolIcon2,
  medicalcare: MedicalCare,
  culture: Culture,
  travel: Travel,
  religion: Religion,
  supermarket: Supermarket,
  accommodation: Accommodation,
  chemicalindustry: ChemicalIndustry,
  enterprise: Enterprise,
  gasstation: GasStation,
  coalmine: CoalMine,
  doc: DocIcon,
  xls: XlsIcon,
  pdf: PdfIcon,
  search: SearchIcon,
  collector: CircleAddIcon,
  MinusIcon: MinusIcon,
  circleMinus: CircleMinusIcon,
  importer: ImporterIcon,
  exporter: ExporterIcon,
  recycle: RecycleIcon,
  alert: AlertIcon,
  editor: EditIcon,
  delete: DeleteIcon,
  review: UserFullIcon,
  time: TimeIcon,
  zrzhIcon: ZrzhLogoIcon,
  questionIcon: QuestionIcon,
  processIcon: ProcessIcon,
  expandIcon: ExpandIcon,
  retractIcon: RetractIcon,
  mark: MarkIcon,
  treeSwitchIcon: TreeSwitchIcon,
  fontBold: FontBoldIcon,
  fontItalic: FontItalicIcon,
  fontUderline: FontUderlineIcon,
  fontColor: FontColorIcon,
  fontCode: FontCodeIcon,
  fontH1: FontH1Icon,
  fontH2: FontH2Icon,
  fontQuote: FontQuoteIcon,
  fontOrderList: FontOrderListIcon,
  fontBulletList: FontBulletListIcon,
  fontLeft: FontLeftIcon,
  fontCenter: FontCenterIcon,
  fontRight: FontRightIcon,
  fontJustify: FontJustifyIcon,
  fontLineHeight: FontLineHeightIcon,
  fontIndent: FontIndentIcon,
  image: ImageIcon,
  editorDelete: EditorDeleteIcon,
  userGroup: UserGroupIcon,
  users: UsersIcon,
  monk: MonkIcon,

  // 上下箭头
  chevronDown: ChevronDownIcon,
  chevronUp: ChevronUpIcon,
  manualIcon: ManualIcon,
  loginUserNameIcon: LoginUserNameIcon,
  loginPasswordIcon: LoginPasswordIcon,
  loginByPhoneIcon: LoginByPhoneIcon,
  loginByPasswordIcon: LoginByPasswordIcon,
  loginMobileIcon: LoginMobileIcon,
  // 字段绑定编辑
  addBoldIcon: AddBoldIcon,
  linkIcon: LinkIcon,
  multiSelect: MultiSelect,
  multiText: MultiText,
  numberIcon: NumberIcon,
  selectIcon: SelectIcon,
  shiftIcon: ShiftIcon,
  textIcon: TextIcon,
  unlinkIcon: UnlinkIcon,
  greenRightIcon: GreenRightIcon,
  normalFieldIcon: NormalFieldIcon,
  areaIcon: AreaIcon,
  geolocationIcon: GeolocationIcon,
  standardIcon: StandardIcon,
  // 已绑定节点图标
  checkCircle: CheckCircle,
  linkNormalIcon: LinkNormalIcon,
  unLinkNormalIcon: UnLinkNormalIcon,
  redDeleteIcon: RedDeleteIcon,
  drag: DragIcon,
  setting: SettingIcon,
  refresh: RefreshIcon,
  check: CheckIcon,
  rank: RankIcon,
  // 通知公告
  noticeIcon: NoticeIcon,
  // 政策要闻
  importantNewsIcon: ImportantNewsIcon,
  // 政策法规
  statuteIcon: StatuteIcon,
  // 政务要闻
  governmentAffairsIcon: GovernmentAffairsIcon,
  // 互动
  interactIcon: InteractIcon,
  // 联系方式
  contractIcon: ContractIcon,
  // 便民指南
  guideIcon: GuideIcon,
  // 专题专栏
  specialColumnIcon: SpecialColumnIcon,
  // 城市概况
  cityIcon: CityIcon,
  // 信息公开
  infomationIcon: InfomationIcon,
  // 留言
  leaveMsgIcon: LeaveMsgIcon,
  // 向左箭头（箭头右侧带横线）
  leftArrow1Icon: LeftArrow1Icon,

  // 点赞
  praiseIcon: PraiseIcon,
  // 评论
  commentIcon: CommentIcon,
  // 转发
  forwardIcon: ForwardIcon,
  // 刷新（换一换）
  refreshIcon: RefreshIcon,
  // 私人认证
  authPrivateIcon: AuthPrivateIcon,
  // 官方认证
  authPublicIcon: AuthPublicIcon,
  workspace: WorkSpaceIcon,
  geo: GeoIcon,
  calendar: CalendarIcon,
  move: MoveIcon,

  // 新的地图左侧图标：
  jzwzcbk: JzwzcbkIcon,
  shzzjznl: ShzzjznlIcon,
  slxfdwyzb: SlxfdwyzbIcon,
  sqxzcjznl: SqxzcjznlIcon,
  xzjdjznl: XzjdjznlIcon,
  yjbns: YjbnsIcon,
  zfzrzhglnl: ZfzrzhglnlIcon,
  zfzzhqsyzz: ZfzzhqsyzzIcon,
  yjsj: yjsjIcon,

  // 湛江-实地检查icon
  zjsdjcIcon: ZjsdjcIcon,
  // 湛江-文明实践中心icon
  zjwmsjIcon: ZjwmsjIcon,
  // 湛江-文明单位管理
  zjwmdwglIcon: ZjwmdwglIcon,
  // 湛江-道德规范与身边好人
  zjddgfysbhrIcon: ZjddgfysbhrIcon,
  // 湛江-文明实践中心icon
  // 应用列表
  foldUp: FoldUpIcon,
  apps: AppsIcon,
  point: PointIcon,
  indexLib: IndexLibIcon,
  category: CategoryIcon,
  // 默认用户头像icon
  defaultAvatarIcon: DefaultAvatarIcon,
  gw: GwIcon,
  // 排序icon
  sort: SortIcon,
  // 外部环境项目icon
  wbhj: WbhjIcon,
  // 大东区垃圾分类项目icon
  ddljfl: DdljflIcon,
  // 广西电网项目icon
  gxdw: GxdwIcon,
  // 大东垃圾分类演示项目icon
  ddljfldemo: DdljflDemoIcon,
  // 导航-厨余垃圾溯源icon
  cyljsy: cyljsyIcon,
  // 导航-可回收物溯源icon
  khswsy: khswsyIcon,
  // 导航-有害垃圾溯源icon
  yhljsy: yhljsyIcon,
  // 导航-督导员监控icon
  ddyjk: ddyjkIcon,
  // 导航-设备监控icon
  sbjk: sbjkIcon,
  // 导航-场景台账icon
  cjtz: cjtzIcon,
  // 导航-设备台账icon
  sbtz: sbtzIcon,
  // 导航-实地检查icon
  sdjc: sdjcIcon,
  // 导航-车辆台账icon
  cltz: cltzIcon,
  // 导航-人员台账icon
  rytz: rytzIcon,
  // 导航-材料申报icon
  clsb: clsbIcon,
  // 导航-宣传活动icon
  xchd: xchdIcon,
  contract: contarctIcon,
  expand: expandIcon,
  // 海淀项目icon
  hd: hdIcon,
  // 丰台项目icon
  ft: ftIcon,
}
